import { createSlice } from "@reduxjs/toolkit";

export const PostMailSlice = createSlice({
  name: "postmail",
  initialState: {
    isPostChecked: false,
    companyName: "",
    countryCode: "US",
    selectedState: "",
    countryName: "",
    streetAddress: "",
    addLine2: "",
    addLine3: "",
    addLine4: "",
    addLine5: "",
    city: "",
    zipCode: "",
    isStreetInValid: null,
    isCityInValid: null,
    isSelectedStateInValid: null,
    isZipCodeInValid: null,
  },
  reducers: {
    changePostalMailSection: (state, action) => {
      state.isPostChecked = action.payload;
    },
    changeCompanyName: (state, action) => {
      state.companyName = action.payload;
    },
    changeCountryCode: (state, action) => {
      state.countryCode = action.payload;
    },
    changeSelectedState: (state, action) => {
      state.selectedState = action.payload;
    },
    changeCountryName: (state, action) => {
      state.countryName = action.payload;
    },
    changeStreetAddress: (state, action) => {
      state.streetAddress = action.payload;
    },
    changeAddLine2: (state, action) => {
      state.addLine2 = action.payload;
    },
    changeAddLine3: (state, action) => {
      state.addLine3 = action.payload;
    },
    changeAddLine4: (state, action) => {
      state.addLine4 = action.payload;
    },
    changeAddLine5: (state, action) => {
      state.addLine5 = action.payload;
    },
    changeCity: (state, action) => {
      state.city = action.payload;
    },
    changeZipCode: (state, action) => {
      state.zipCode = action.payload;
    },
    changeIsStreetValid: (state, action) => {
      state.isStreetInValid = action.payload;
    },
    changeIsCityValid: (state, action) => {
      state.isCityInValid = action.payload;
    },
    changeIsSelectedStateValid: (state, action) => {
      state.isSelectedStateInValid = action.payload;
    },
    changeIsZipCodeInValid: (state, action) => {
      state.isZipCodeInValid = action.payload;
    },
  },
});

export const {
  changePostalMailSection,
  changeCompanyName,
  changeCountryCode,
  changeSelectedState,
  changeCountryName,
  changeStreetAddress,
  changeAddLine2,
  changeAddLine3,
  changeAddLine4,
  changeAddLine5,
  changeCity,
  changeZipCode,
  changeIsStreetValid,
  changeIsCityValid,
  changeIsSelectedStateValid,
  changeIsZipCodeInValid,
} = PostMailSlice.actions;
export default PostMailSlice.reducer;
